import { THierarchyItemCreateForm } from 'core/model/interfaces/navigation/hierarchy.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { getErrorFromService } from 'shared/utils/https';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../../constants';
import { getUnexpectedErrorMessages } from '../../navigation.utils';
import { INavigationState } from '../../types';

export const createNavigationItem = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/createNavigationItem`,
  async ({ data }: { data: THierarchyItemCreateForm }) => {
    try {
      await apiService.hierarchy.createHierachyItem(data);
      notificationService.global.success('Mundo creado correctamente.');
    } catch (error) {
      notificationService.drawer.error(getErrorFromService(error, getUnexpectedErrorMessages('items', 'create')));
      throw error;
    }
  },
);

export const createNavigationItemReducer: TSliceExtraReducer<INavigationState> = builder =>
  builder
    .addCase(createNavigationItem.pending, state => {
      state.form.loading = true;
      state.form.success = false;
    })
    .addCase(createNavigationItem.rejected, state => {
      state.form.loading = false;
      state.form.success = false;
    })
    .addCase(createNavigationItem.fulfilled, state => {
      state.form.loading = false;
      state.form.success = true;
    });
